import BaseFieldView from './BaseFieldView';
export default BaseFieldView;
